import { RDTillage } from '@cibo/core'
import { TillageChip } from '@cibo/ui'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { TillagePanelTable } from './TillagePanelTable'

export const TillagePanel = () => {
  const { t } = useTranslation('@cibo/landmanager/TillagePanel')

  return (
    <DetailPanel<RDTillage>
      title={t('tillage')}
      traitId="tillage"
      DetailTable={TillagePanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDTillage }) => (
        <TillageChip type={currentYearData?.result} source={currentYearData?.source} />
      )}
    />
  )
}
